export default {
  categories: []
}
  